import axios, { AxiosError } from 'axios';
import { ApiFinanceira } from '../axiosfinanceiro';

interface ContasPagas {
  dataemissao: Date;
  datalan: Date;
  parceiro: string;
  historico: string;
  fazenda: string;
  banco: string;
  numerodoc: string;
  valor: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const RelatorioContasPagas = async (parceiro: string, fazenda: string, planoconta: string, datainicial: string, datafinal: string): Promise<ContasPagas[] | Error> => {
  try {
    const urlRelativa = `/relatoriocontaspagas?fazenda=${fazenda}&parceiro=${parceiro}&planoconta=${planoconta}&datainicial=${datainicial}&datafinal=${datafinal}`;
      
    const { data } = await ApiFinanceira.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
  

export const RelatorioContasPagasService = {
  RelatorioContasPagas
};